import { useEffect, useRef, useState } from "react"
import useOrientation from "@/hooks/useOrientation"
import Topbar from "@/components/topnav"
import { useNavigate } from "react-router-dom"

const NotFound = () => {
  const { isPortrait, isLandscape, isStandalone } = useOrientation()

  const navigate = useNavigate()
  const [seconds, setSeconds] = useState(8)
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/library")
    }, seconds * 1000)

    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1)
    }, 1000)

    return () => {
      clearTimeout(timer)
      clearInterval(interval)
    }
  }, [navigate, seconds])

  useEffect(() => {
  const canvas = canvasRef.current
  if (!canvas) return

  const ctx = canvas.getContext("2d")
  if (!ctx) return

  let width = window.innerWidth
  let height = window.innerHeight

  canvas.width = width
  canvas.height = height

  const random = (min: number, max: number) =>
    Math.random() * (max - min) + min

  const map = (
    value: number,
    inMin: number,
    inMax: number,
    outMin: number,
    outMax: number
  ) =>
    ((value - inMin) * (outMax - outMin)) /
      (inMax - inMin) +
    outMin

  const minSize = 8
  const maxSize = 30

  let accelerate = false

  const words: {
    x: number
    y: number
    text: string
    size: number
  }[] = []

  const texts = [
    "NOT FOUND",
    "MIXTAPE",
    "404",
    "HELP xD",
  ]

  for (let i = 0; i < 100; i++) {
    words.push({
      x: random(0, width),
      y: random(0, height),
      text: texts[Math.floor(random(0, texts.length))],
      size: random(minSize, maxSize),
    })
  }

  let frame = 0

  const render = () => {
    frame = requestAnimationFrame(render)

    ctx.fillStyle = "#000"
    ctx.fillRect(0, 0, width, height)

    ctx.fillStyle = "rgba(255,255,255,.12)"

    words.forEach(word => {
      ctx.font = `${word.size}px Monument, sans-serif` /* Inter */
      ctx.fillText(word.text, word.x, word.y)

      /* word.x +=
        map(word.size, minSize, maxSize, 0.5, 3.5) *
        (accelerate ? 2 : 1) */

      word.x +=
        map(word.size, minSize, maxSize, 0.5, 3.5) *
        speedMultiplier *
        (accelerate ? 2 : 1)

      const measure = ctx.measureText(word.text)

      if (word.x > width + measure.width) {
        word.x = -measure.width
        word.y = random(0, height)
        word.size = random(minSize, maxSize)
      }
    })
  }

  const speedMultiplier = isPortrait ? 0.2 : 0.75


  render()

  const resize = () => {
    width = window.innerWidth
    height = window.innerHeight

    canvas.width = width
    canvas.height = height
  }

  const down = () => (accelerate = true)
  const up = () => (accelerate = false)

  window.addEventListener("resize", resize)
  window.addEventListener("keydown", down)
  window.addEventListener("keyup", up)

  return () => {
    cancelAnimationFrame(frame)
    window.removeEventListener("resize", resize)
    window.removeEventListener("keydown", down)
    window.removeEventListener("keyup", up)
  }
}, [])


  return (
    
    <div className="
      relative w-full h-[100dvh]
      overflow-hidden overscroll-none
      touch-pan-y">
    <Topbar />
    
    <div className={`

    relative

    z-10
        inset-0 flex flex-col overflow-hidden
        
        w-full
        select-none
        ${isLandscape ? "bg-[var(--movil-nav)] h-[calc(100%-3.7rem)] border border-white/15 rounded-xl overscroll-y-none" : ""}
        ${isPortrait ? "h-[100dvh] pb-0 mb-0" : "" }
        ${isStandalone ? "h-[100dvh] mb-40" : "" }
      `}>


        <canvas ref={canvasRef}
            className="
              absolute
              inset-0
              w-full
              h-full
              z-0
              pointer-events-none
            "/>

    <div className="z-10 flex h-full flex-col items-center justify-center text-white rounded-2xl text-center">
      <h1 className="mb-4 text-lg font-semibold tracking-wide">
        RUTA INCORRECTA
      </h1>

      <button
        onClick={() => navigate("/library")}
        className="
          mt-2
          w-60
          rounded-full
          bg-white
          px-4
          py-3
          text-sm
          font-semibold
          text-black
          transition-all
          duration-300
          active:scale-95
          hover:bg-white/80
        "
      >
        Veamos las listas en {seconds}
      </button>
      
    </div>
    </div>
    </div>
  )
}

export default NotFound